import React from 'react';
import { Link } from 'react-router-dom';

import { getEnv } from '../../../../lib/utils/getEnv';

const { VITE_CDN_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

export const TOP_FEATURES_TITLES_CONFIG = [
  {
    title: 'Take online bookings',
    description: () => (
      <p>
        Let pet owners book your hydrotherapy services through the{' '}
        <Link to="/business/features#marketing">Pata Marketplace</Link>. Our online diary for pet therapy businesses
        gives clients 24/7 access to your schedule for easy and stress-free bookings.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-lady-using-pata-on-laptop.webp`,
  },
  {
    title: 'Case management without the paperwork',
    description: () => (
      <p>
        Easily track hydrotherapy progress in dogs or other pets. Add detailed notes about furry or human clients,
        upload documents, and view medical information in one central, secure platform.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-dog-having-treat.webp`,

    action: {
      actionText: 'Book a demo',
      onClick: () => {
        window.location = `https://meetings.hubspot.com/pata/demo`;
      },
      buttonType: 'secondary',
    },
  },
  {
    title: 'Simplify admin for your hydrotherapy business',
    description: () => (
      <p>
        Manage repeat clients and vet referrals, organise your schedule, and send automated session reminders — all
        cutting your time spent on admin.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-dog-with-letters.webp`,
  },
  {
    title: 'Easy-to-use booking platform',
    description: () => (
      <p>
        Quickly find and manage your sessions with our intuitive hydrotherapy appointment software, designed with
        simplicity in mind. For anything you’re unsure about, Pata’s customer support team is on hand to help.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-lady-holding-dog-with-laptop.webp`,
    action: {
      actionText: 'Join Pata',
      onClick: () => {
        window.location = `${VITE_PARTNERS_BASE_URL}/sign-up`;
      },
      buttonType: 'primary',
    },
  },
  {
    title: 'Find pet owners in your local area',
    description: () => (
      <p>
        List your rehabilitation services and reviews on the{' '}
        <Link to="/business/features#marketing">Pata Marketplace </Link> to boost your online visibility and grow a
        network of clients who are looking for hydrotherapy sessions.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-dog-in-bath.webp`,
  },
];
